module.exports = __webpack_public_path__ + "static/media/ap-logo-black.2328103c.png";